import { chakra } from '@chakra-ui/react';

import { useSearchInputStyles } from '../SearchInputStylesContext';

export type HintProps = {
  hintToShow: string | undefined | null;
};

export const Hint = ({ hintToShow }: HintProps) => {
  const { hint: hintStyles } = useSearchInputStyles();

  return <chakra.span __css={{ ...hintStyles }}>{hintToShow}</chakra.span>;
};
